
export const CREDIT_LEVELS = {
  1 : {
    key: 1,
    color: 'success',
    icon: '',
  },
  2 : {
    key: 2,
    color: 'warning',
    icon: '',
  },
  3 : {
    key: 3,
    color: 'red',
    icon: '',
  },
}